import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { uiActions } from '../../actions/index';
import ProjectsList from './ProjectsList';
import ProjectDetails from './ProjectDetails';
import ProjectCreateOrEdit from './ProjectCreateOrEdit';
import './Projects.css';

class Projects extends React.Component {
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(uiActions.projectClicked(undefined));
    dispatch(uiActions.addProjectClicked(false));
    dispatch(uiActions.editProjectClicked(undefined));
  }

  renderRightComponent() {
    const { isAddProject, editProject, project } = this.props;
    if (isAddProject || editProject) {
      return <ProjectCreateOrEdit project={editProject} />;
    }
    if (project) {
      return <ProjectDetails />;
    }
    return <div />;
  }

  render() {
    return (
      <div className="projects-root">
        <ProjectsList />
        {this.renderRightComponent()}
      </div>
    );
  }
}

Projects.propTypes = {
  dispatch: PropTypes.func.isRequired,
  project: PropTypes.shape({}).isRequired,
  isAddProject: PropTypes.bool.isRequired,
  editProject: PropTypes.shape({
    id: PropTypes.string.isRequired,
    ownerUid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    archivedAt: PropTypes.string,
    hourlyRate: PropTypes.number.isRequired,
    currencyCode: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  project: state.projectDetails.project,
  isAddProject: state.uiState.isAddProject,
  editProject: state.uiState.editProject,
});

export default connect(mapStateToProps)(Projects);



// WEBPACK FOOTER //
// ./src/components/projects/Projects.js